module.exports = __webpack_public_path__ + "img/WE_blog5.fd673eb4.png";